import { Card, emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { currentUserStore } from '../../../../CurrentUserStore';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import EmptyRecentActivity from '../../../EmptyComponents/EmptyRecentActivity';
import CardTitle from '../../Shared/CardTitle';
import { recentActivitiesResourceDecoder } from './Decoders';
import RecentActivitySkeleton from './RecentActivitySkeleton';
import Row from './Row';

function RecentActivity() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'recent-activities',
    currentUserStore.links,
    recentActivitiesResourceDecoder,
  );

  if (isLoading) {
    return <RecentActivitySkeleton />;
  }

  if (error || !data) {
    console.error('Failed to load recent activities:', error);
    return emptyFragment();
  }

  return (
    <div className="mt-7">
      <CardTitle title="Participant Milestones" />
      <Card className="w-full pt-7 pr-6 pb-4 pl-6 max-h-52.5" radius="lg">
        {fromArrayMaybe(data.payload)
          .map((recentActivities) => <Row recentActivities={recentActivities} />)
          .getOrElse(() => (
            <EmptyRecentActivity />
          ))}
      </Card>
    </div>
  );
}

export default observer(RecentActivity);
